import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApplicationStore } from '@core/stores/application.store';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-user-address-card',
  imports: [
    FormsModule,
    TranslatePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './user-account-card.component.html'
})
export class UserAccountCardComponent {
  readonly applicationStore = inject(ApplicationStore);

}
